import React from 'react';
import {Breadcrumb} from "flowbite-react";
import {HiHome} from "react-icons/hi";
import {IoDocumentText} from "react-icons/io5";
import DocSection from "./DocSection";

const ImportantNotes = () => {
    return (
        <section className="bg-white dark:bg-gray-700">
            <Breadcrumb aria-label="Breadcrumb navigation" className="bg-gray-100 px-5 py-3 dark:bg-gray-900">
                <Breadcrumb.Item href="/" icon={HiHome}>Home</Breadcrumb.Item>
                <Breadcrumb.Item href="/documentation" icon={IoDocumentText}>Documentation</Breadcrumb.Item>
                <Breadcrumb.Item>
                    <span className="text-gray-900 dark:text-white">Important Notes</span>
                </Breadcrumb.Item>
            </Breadcrumb>

            <div className="mx-auto max-w-screen-md text-center my-8">
                <h1 className="text-4xl font-extrabold text-gray-900 dark:text-white">
                    Important Notes
                </h1>
                <p className="mt-2 text-lg text-gray-700 dark:text-gray-300">
                    Key considerations and important notes to keep in mind when using our system
                </p>
            </div>

            <div className="mx-auto max-w-screen-lg pb-8">
                <DocSection
                    title="Uptime"
                    description="Since all features are currently free, we will do our best to keep the system up and
                    running, but there is no guarantee of 100% uptime."
                    examples={[]}
                />
                <DocSection
                    title="Data Privacy"
                    description="We do not store any data from your form submissions. Please ensure you keep and manage
                    your important information independently."
                    examples={[]}
                />
                <DocSection
                    title="Security"
                    description="To enhance security and prevent attacks, all requests must include a referrer or origin
                    header. Requests missing these headers will not be processed."
                    examples={[]}
                />
                <DocSection
                    title="Terms of Use"
                    description="By using our system, you agree to our terms and conditions. Please ensure you have read and understood them before proceeding."
                    examples={[]}
                />
                <DocSection
                    title="Need help?"
                    description="Got a technical issue? Want to send feedback? Need details about our product? Let us
                    know from contact us form of the main page."
                    examples={[]}
                />
            </div>
        </section>
    );
};

export default ImportantNotes;
